var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMiniCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    fill: "#28353C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3896_30599)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.37328 7.06374L3.07203 5.76249C2.92578 5.61624 2.68953 5.61624 2.54328 5.76249C2.39703 5.90874 2.39703 6.14499 2.54328 6.29124L4.11078 7.85874C4.25703 8.00499 4.49328 8.00499 4.63953 7.85874L8.60703 3.89125C8.75328 3.745 8.75328 3.50875 8.60703 3.3625C8.46078 3.21625 8.22453 3.21625 8.07828 3.3625L4.37328 7.06374Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3896_30599"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    fill: "white",
    transform: "translate(1 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniCheck);
export default __webpack_public_path__ + "static/media/miniCheck.7766a19b9e5e942b8c760490b6055590.svg";
export { ForwardRef as ReactComponent };